<div class="credit-bar-container" [appShimmer]="isLoading()">
  @if (!isLoading()) {
    <div class="credit-bar-credit credit-complete" *libRepeat="completedCount()"></div>
    <div class="credit-bar-credit credit-incomplete" *libRepeat="maxCount() - completedCount()"></div>
  }
</div>
